// Mirrors FleetHd.Issue IssueDto (root). An Issue is an aggregate of evidence
// (contributions) about one problem on one vehicle. The backend never stores
// null — unset values are empty strings / empty objects / empty arrays.

import { ContributionDto } from './contribution';
import { StateHistoryEntryDto } from './state-history';
import { DispositionDto } from './disposition';
import { ReferenceDto } from './reference';
import { MetricSnapshotDto } from './metric-snapshot';
import { IssueCaseDto } from './issue-case';
import { ActivityEntryDto } from './activity-entry';

export const IssueLifecycleStates = {
  Emerging: 'Emerging', Active: 'Active', Fading: 'Fading', Closed: 'Closed',
} as const;
export type IssueLifecycleState = typeof IssueLifecycleStates[keyof typeof IssueLifecycleStates];

// The lifecycle states the list-by-vehicle endpoint actually returns (it filters
// to active states — Closed is never present in the widget's data).
export const OPEN_LIFECYCLE_STATES: IssueLifecycleState[] = [
  IssueLifecycleStates.Active, IssueLifecycleStates.Emerging, IssueLifecycleStates.Fading,
];

export interface IssueDto {
  id: string;
  createDateTimeUtc: string;
  updateDateTimeUtc: string;
  assetId: string;
  assetName: string;
  assetVin: string;
  fingerprint: string;
  category: string;
  confidence: number;        // 0–1
  severity: number;          // 1–100
  lifecycleState: IssueLifecycleState;
  canonicalName: string;
  displayName: string;       // human-friendly title — use as the card/row title
  // The symptoms of the live evidence, shown next to the name. Empty on an Issue that
  // has none yet; the name then stands alone.
  description?: string;
  contributions: ContributionDto[];
  stateHistory: StateHistoryEntryDto[];
  activity: ActivityEntryDto[];   // append-only operator-facing timeline
  disposition: DispositionDto;
  references: ReferenceDto[];
  metricSnapshots: MetricSnapshotDto[];
  cases: IssueCaseDto[];
  reopenCount: number;
  lastReopenedAt: string;
}
